import { useEffect, useState } from 'react';
import AddLegsModal from './addLegsModal';
import { ManualLegDto } from '../../../types';
import { AddManualLegInitialValue } from '../../../initial-values';
import ManualLegCard from './legCard';
import plus from '../../../assets/icons/new_icon/plus-icon.svg';
import map from '../../../assets/icons/new_icon/map-placeholder.svg';
import AlertModal from '../../global-components/alertModal';

interface Props {
  manualLegList: any;
  setManualLegList: any;
  validating: boolean;
}
function ManualLegsForm({
  manualLegList,
  setManualLegList,
  validating,
}: Props) {
  const [showAddLegModal, setShowAddLegModal] = useState(false);

  const handleUpdateLegForm = (updatedItem: any, index: number) => {
    const updatedLegList = [...manualLegList];
    updatedLegList[index] = updatedItem;
    setManualLegList(updatedLegList);
  };
  const handleRemoveLeg = (index: number) => {
    const updatedLegList = [...manualLegList];
    updatedLegList.splice(index, 1);
    setManualLegList(updatedLegList);
  };
  return (
    <>
      <div className='row px- mt-lg-0'>
        <div className='col-4 col-md-2'>
          <button
            className='btn ubbe-blue-bg p-2  px-3  rounded-3 text-light align-items-center '
            data-bs-toggle='modal'
            style={{ height: '48px', marginTop: '-30px' }}
            data-bs-target='#add_leg_modal'
            onClick={() => setShowAddLegModal(true)}
          >
            <img
              src={plus}
              className='me-2'
              alt=''
            />{' '}
            Add Leg
          </button>
        </div>
        <div className='col-4 col-2 col-md-10'></div>
        <div className='col-4 col-2 col-md-1 text-end'></div>
      </div>
      {!manualLegList?.length && (
        <div className='row'>
          <div className='col-12'>
            <div className='card-body p-4 text-center d-flex flex-column '>
              <div>
                <img
                  src={map}
                  alt=''
                />
              </div>
              <label className='boldsteppertext mt-4'>Please Add a Leg!</label>
            </div>
          </div>
        </div>
      )}

      <div id='leg_cards'>
        {manualLegList &&
          manualLegList.length > 0 &&
          manualLegList.map((item: ManualLegDto, index: number) => (
            <ManualLegCard
              legData={item}
              setLegData={(updatedItem: ManualLegDto) => {
                handleUpdateLegForm(updatedItem, index);
              }}
              handleRemoveLeg={handleRemoveLeg}
              validating={validating}
              index={index}
              manualLegList={manualLegList}
              setManualLegList={setManualLegList}
            />
          ))}
      </div>
      {showAddLegModal && (
        <AddLegsModal
          onClose={() => {
            setShowAddLegModal(false);
          }}
          manualLegList={manualLegList}
          setManualLegList={setManualLegList}
        />
      )}
      {/* {showDeleteAlert && (
        <AlertModal
          description={'Are you sure you want to delete?'}
          title='Confirm Deletion'
          confirmTitle={'Delete'}
          onClose={() => {
            setShowDeleteAlert(false);
            setSelectedItemId('');
          }}
          onSuccess={() => {
            deleteContact(selectedItemId);
          }}
        />
      )} */}
    </>
  );
}

export default ManualLegsForm;
